import { createAuthClient } from "better-auth/client";
import { adminClient, phoneNumberClient } from "better-auth/client/plugins";

export const authClient = createAuthClient({
  // Se o seu cliente e servidor estiverem em domínios diferentes,
  // adicione a baseURL aqui.
  plugins: [
    adminClient(),
    phoneNumberClient(),
  ],
});
